<template>
  <Swiper
    :slidesPerView="1"
    :spaceBetween="10"
    :centeredSlides="false"
    :preventClicks="true"
    :loop="true"
    :autoplay="{
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    }"
    :speed="18000"
    :direction="horizontal"
    :zoom="true"
    :keyboard="{
      enabled: true,
      onlyInViewport: false,
    }"
    :breakpoints="{
      0: { slidesPerView: 1 },
      370: { slidesPerView: 1.5 },
      450: { slidesPerView: 2 },
      576: { slidesPerView: 2 },
      768: { slidesPerView: 2 },
      800: { slidesPerView: 3 },
      992: { slidesPerView: 2.5 },
      1440: { slidesPerView: 3 },
      1600: { slidesPerView: 3.5 },
    }"
    :modules="modules"
    class="banner-slide-2 mb-2"
    dir="rtl"
  >
    <SwiperSlide v-for="(slide, i) in effectiveSlides" :key="i">
      <img :src="slide.image" alt="slide" />
    </SwiperSlide>
  </Swiper>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay } from "swiper/modules";

const defaultImages = [
  require("@/assets/images/slide-5.jpg"),
  require("@/assets/images/slide-6.jpg"),
  require("@/assets/images/slide-7.jpg"),
  require("@/assets/images/slide-8.jpg"),
];

export default defineComponent({
  name: "BannerSlideTwo",
  components: { Swiper, SwiperSlide },
  props: {
    customImages: { type: Array as () => Array<{ image_url: string }>, default: () => [] },
  },
  setup(props) {
    const effectiveSlides = computed(() => {
      const cms = props.customImages.filter((i) => i.image_url).map((i) => ({ image: i.image_url }));
      const base = cms.length > 0 ? cms : defaultImages.map((img) => ({ image: img }));
      return [...base, ...base];
    });
    return { effectiveSlides, modules: [Autoplay] };
  },
});
</script>
